import { createAction, props } from "@ngrx/store";

import { FailState } from "../models/fail-state";

export class PublicActions {
	static readonly countries = {
		get: createAction("[Countries Public] Get"),
		getSuccess: createAction("[Countries Public] Get Success"),
		getFail: createAction("[Countries Public] Get Fail", props<FailState>())
	};
}
